// utilities
import fitvid from './base/_fitvid';
import focusWithin from './components/_focus-within';
import throttle from './base/_throttle';

// feature classes
import Navigation from './components/_navigation';
import Footer from './components/_footer';
import GravityForm from './components/_gravity-form';
import swiftype from './components/_swiftype';
import Modal from './components/_modal';

import VideoBlock from './blocks/_wp-block-video';
import KcardVideo from './blocks/_kcard-video';

import hubspotFix from './components/_hubspot-fix';

class Kendal {
	constructor(opts = {}) {
		this.opts = Object.assign({
			resizeThrottle: 50
		}, opts);

		if (document.readyState.match(/complete|interactive/)) {
			this.ready();
		} else {
			document.addEventListener('DOMContentLoaded', this.ready.bind(this));
		}

		// export Modal for other scripts
		this.Modal = Modal;

		window.addEventListener('load', this.load.bind(this));
		window.addEventListener('resize', throttle(this.resize.bind(this)), this.opts.resizeThrottle);
	}

	ready() {
		this.navigation = new Navigation();
		this.footer = new Footer();
		this.gravityForms = Array.from(document.querySelectorAll('.gform_wrapper form')).map(form => new GravityForm(form));
		this.swiftype = swiftype();
		focusWithin('form');
		fitvid();
		hubspotFix.init();
		this.videos();
		this.cards();

		this.modalLinks = Array.from( document.querySelectorAll( '.wp-block-image.use-modal a[href]' ) ).map( link => {
			const modal = new Modal(
				`<iframe src="${link.href}" class="modal__iframe" border="0" frameborder="0"></iframe>`,
				{
					closeText: '',
					modifier: 'video',
					onopen  : () => fitvid()
				}
			);

			link.classList.add( 'outbound-bypass' );

			link.addEventListener( 'click', e => {
				e.preventDefault();
				modal.open();
			} );

			return modal;
		} );
	}

	videos() {
		if (!this._videos) {
			this._videos = [];
		}

		// Array.from(document.querySelectorAll('.wp-block-video')).forEach(n => {
		// 	this._videos.push(new VideoBlock(n));
		// });

		Array.from(document.querySelectorAll('.kcard--video')).forEach(n => {
			this._videos.push(new KcardVideo(n));
		});

		Array.from(document.querySelectorAll('.wp-block-media-text video')).forEach(n => {
			this._videos.push(VideoBlock.mediaText(n));
		});
	}

	cards() {
		Array.from(document.querySelectorAll('.kcard')).forEach(kcard => {
			if (kcard.children && kcard.children[0].classList.contains('wp-block-image')) {
				kcard.classList.add('kcard--has-image');
			}
		});
	}

	load() {

	}

	resize() {
		document.body.dispatchEvent(new CustomEvent('kendal:resize'));
	}
}

export default new Kendal;
